import {inject} from "vue";

export default function () {
    const logger = inject('vuejs3-logger');
    return {logger}
}